import QueryParamsUtils from "../utils/query-params.utils";
export default class CheckoutHandler {
  constructor(domUtils, cartService) {
    this.domUtils = domUtils;
    this.cartService = cartService;
    this.selectors = Object.freeze({
      formContainer: "#slidecart-checkout-form",
      discountCodeParameter: "discount_code"
    });
  }
  async init(cartContainer) {
    try {
      const form = (await this.domUtils.waitForElement(this.selectors.formContainer, cartContainer)) || document.querySelector(this.selectors.formContainer);
      if (!form) {
        console.error("Discount Form not loaded");
        return;
      }
      const button = form.querySelector("button");
      if (!button) {
        return;
      }
      button.addEventListener("click", async e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const code = QueryParamsUtils.getUrlParameter(this.selectors.discountCodeParameter);
        if (!code) {
          window.location.href = "/checkout";
          return;
        }
        const result = await this.cartService.validateDiscount(code);
        window.location.href = result?.permalink || "/checkout";
      }, {
        once: true
      });
    } catch (error) {
      throw error;
    }
  }
}